import RestService from './RestService';

export default class InfosecService extends RestService {
    summary() {
        return this.get(`/infosec/assessment/summary`);
    }
}
